import { Injectable, Injector, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import { ConfigurationService } from "../configuration.service";
import { EndpointFactory } from "../endpoint-factory.service";
import { environment } from "../../../environments/environment";

// Cognito
import { CognitoService } from "../cognito/cognito.service";

@Injectable()
export class NotificationEndpoint extends EndpointFactory {
  private host = environment.assistanceUrl;
  private notificationsiUrl: string = this.host + "notifications";
  private appVersionUrl: string = this.notificationsiUrl + "app/version";
  private appFeaturesUrl: string =
    this.notificationsiUrl + "app/features/version";

  constructor(
    protected http: HttpClient,
    protected configurations: ConfigurationService,
    injector: Injector,
    cognitoService: CognitoService /*, @Inject('BASE_URL') private baseUrl: string*/
  ) {
    super(http, configurations, injector, cognitoService);
  }

  /**
   * Api call to retrieves app version.
   */
  public getAppVersion<T>(): Observable<T> {
    return this.http
      .get<T>(this.appVersionUrl, this.getRequestHeaders())
      .catch((error) => {
        return this.handleError(error);
      });
  }

  /**
   * Api call to retrieves app feauters.
   * @param version Local app version.
   */
  public getAppFeatures<T>(version: number): Observable<T> {
    let headers: HttpHeaders = this.getRequestHeaders().headers as HttpHeaders;

    return this.http
      .get<T>(`${this.appFeaturesUrl}/${version}`, {
        headers,
        responseType: "text" as "json",
      })
      .catch((error) => {
        return this.handleError(error);
      });
  }
}
